import { useEffect, useState } from 'react';
import { Icona } from '../../components/Icona';
import { commesse } from '../../api/commesse';
import type { CommessaAperta } from '../../api/commesse';
import { richieste } from '../../api/acquisti';

/*  UNA RICHIESTA D'ACQUISTO NUOVA DALL'ELENCO DELLE RDA. 19/10/2026, Andrea: «in rda non
    c'e' il pulsante per inserirne una nuova». Fino a qui si apriva solo dalla commessa
    (NuovaRichiesta.tsx); dall'elenco si sceglie prima la commessa, poi le stesse due
    cose — cosa serve e per quando. Nasce vuota come quella: dentro c'e' il bottone che
    pesca dal preventivo, e le righe a mano.  */
export function NuovaRichiestaDaElenco({
  onAnnulla,
  onCreata,
}: {
  onAnnulla: () => void;
  onCreata: (id: string) => void;
}) {
  const [aperte, setAperte] = useState<CommessaAperta[] | null>(null);
  const [commessaId, setCommessaId] = useState('');
  const [descrizione, setDescrizione] = useState('');
  const [fabbisogno, setFabbisogno] = useState(() => {
    const fra = new Date();
    fra.setDate(fra.getDate() + 7);
    return fra.toISOString().slice(0, 10);
  });
  const [inCorso, setInCorso] = useState(false);
  const [errore, setErrore] = useState<string | null>(null);

  useEffect(() => {
    commesse
      .aperte()
      .then(setAperte)
      .catch((e: Error) => setErrore(e.message));
  }, []);

  function scegliCommessa(id: string) {
    setCommessaId(id);
    // La descrizione proposta come dalla commessa, finche' nessuno l'ha scritta.
    const c = aperte?.find((x) => x.id === id);
    if (c && (descrizione === '' || descrizione.startsWith('Materiale per '))) {
      setDescrizione(`Materiale per ${c.descrizione}`);
    }
  }

  const pronto = commessaId !== '' && descrizione.trim() !== '' && fabbisogno !== '';

  async function crea() {
    if (!pronto) return;
    setInCorso(true);
    setErrore(null);
    try {
      const nata = await richieste.crea({
        commessaId,
        descrizione: descrizione.trim(),
        dataFabbisogno: fabbisogno,
      });
      onCreata(nata.id);
    } catch (e) {
      setErrore((e as Error).message);
      setInCorso(false);
    }
  }

  return (
    <aside className="scheda nuova-richiesta-elenco" aria-label="Nuova richiesta d’acquisto">
      <header>
        <div>
          <h2>Nuova richiesta d’acquisto</h2>
        </div>
        <button type="button" className="chiudi" onClick={onAnnulla} aria-label="Chiudi">
          <Icona nome="chiudi" />
        </button>
      </header>

      <label className="campo-blocco">
        <span>Commessa</span>
        <select value={commessaId} onChange={(e) => scegliCommessa(e.target.value)}>
          <option value="">{aperte === null ? 'Leggo le commesse…' : 'Scegli la commessa'}</option>
          {(aperte ?? []).map((c) => (
            <option key={c.id} value={c.id}>
              {c.numero} — {c.descrizione}
              {c.cliente ? ` (${c.cliente})` : ''}
            </option>
          ))}
        </select>
      </label>
      <label className="campo-blocco">
        <span>Cosa serve</span>
        <input value={descrizione} onChange={(e) => setDescrizione(e.target.value)} />
      </label>
      <label className="campo-blocco">
        <span>Serve il</span>
        <input type="date" value={fabbisogno} onChange={(e) => setFabbisogno(e.target.value)} />
      </label>

      {errore && <p className="errore">{errore}</p>}
      <p className="azioni">
        <button type="button" className="primario" disabled={inCorso || !pronto} onClick={() => void crea()}>
          Apri la richiesta
        </button>
        <button type="button" disabled={inCorso} onClick={onAnnulla}>
          Annulla
        </button>
      </p>
    </aside>
  );
}
